import { render, staticRenderFns } from "./NSnackbar.vue?vue&type=template&id=1749b5fc"
import script from "./NSnackbar.vue?vue&type=script&lang=js"
export * from "./NSnackbar.vue?vue&type=script&lang=js"
import style0 from "./NSnackbar.vue?vue&type=style&index=0&id=1749b5fc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports